/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChartScatter} from '@fortawesome/pro-duotone-svg-icons';

const SchedulerAutomatedIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faChartScatter} {...props} />
);

export default SchedulerAutomatedIcon;
